export default {
  details: {
    display: 'flex',
    color: 'black',
    fontSize: '2rem',
    height: '95%',
    gap: '1rem'
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 50%'
  },
  wiringInfo: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '2rem',
    padding: '1rem 1rem 0 1rem'
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  doorControllerIcon: {
    borderRadius: '50%',
    color: 'white',
    flex: '0 1 3.5rem',
    height: '3.5rem',
    display: 'flex',
    marginRight: '1rem',
    fontSize: '1.6rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorDetails/exportStyle.js